import { actions } from 'modules/asset/asset$';
import { courseActions } from 'modules/course/course$';
import {
  showErrorNotification,
  showSuccessNotification,
} from 'modules/notification/notification$';
import { NotificationType } from 'modules/notification/types';
import { collectRoutines, dispatchAction, routine } from 'rxbeach';
import { extractPayload, ofType } from 'rxbeach/operators';
import { tap } from 'rxjs/operators';

const notify =
  (type: NotificationType) => (assets: any, message: string) => {
    const asset = assets?.[0];
    if (!asset) return;
    if (type === NotificationType.SUCCESS) {
      dispatchAction(showSuccessNotification(message));
    } else if (type === NotificationType.ERROR) {
      dispatchAction(showErrorNotification(message));
    }
  };

const notifySuccess = notify(NotificationType.SUCCESS);

const showCreateAssetNotification = routine(
  ofType(actions.create, courseActions.create),
  extractPayload(),
  tap((assets) => notifySuccess(assets, 'Suksess 👍'))
);

const showUpdateAssetNotification = routine(
  ofType(actions.put, courseActions.put),
  extractPayload(),
  tap((assets) => notifySuccess(assets, 'Endringer er lagret 😎'))
);

const showDeleteAssetNotification = routine(
  ofType(actions.remove, courseActions.remove),
  extractPayload(),
  tap((assets) => notifySuccess(assets, 'Sletting sukksess'))
);

const showAssetErrorNotification = routine(
  ofType(actions.error, courseActions.error),
  extractPayload(),
  tap((error) => dispatchAction(showErrorNotification(error)))
);

export const assetNotificationRoutines = collectRoutines(
  showCreateAssetNotification,
  showUpdateAssetNotification,
  showDeleteAssetNotification,
  showAssetErrorNotification
);
